<fui-navigation-tree id="tree-{{index}}" *ngFor="let tree of trees; let index=index" [tree]="tree"></fui-navigation-tree>
